import React, { useContext } from 'react';

import { Skeleton } from '@mui/material';

import { ReactComponent as ChevronRightIcon } from '../../../../../../assets/icons/v3/chevron-right.svg';
import { ReactComponent as CompanyIcon } from '../../../../../../assets/icons/v3/company-building.svg';
import { CompanyContext } from '../../../../../context/company/companyContext';

import './SidebarCompanySelector.scss';

interface SidebarCompanySelectorProps {
  isExpanded: boolean;
  onClick: () => void;
}

const SidebarCompanySelector = ({ isExpanded, onClick }: SidebarCompanySelectorProps) => {
  const { company } = useContext(CompanyContext);

  if (!company.id) {
    return (
      <div className={`sidebar-company-selector loading ${isExpanded ? 'expanded' : ''}`}>
        <Skeleton animation="wave" variant="rounded" className="sidebar-company-selector-skeleton" />
      </div>
    );
  }

  return (
    <button
      type="button"
      className={`sidebar-company-selector ${isExpanded ? 'expanded' : ''}`}
      onClick={onClick}
      aria-label={company.name}
      title={company.name}
    >
      <span className="sidebar-company-selector-content">
        <CompanyIcon className="sidebar-company-selector-icon" aria-hidden="true" />
        {isExpanded && <span className="sidebar-company-selector-name">{company.name}</span>}
      </span>
      {isExpanded && <ChevronRightIcon className="sidebar-company-selector-caret" aria-hidden="true" />}
    </button>
  );
};

export default SidebarCompanySelector;
